import styled from 'styled-components';

export const InputContainer = styled.div`
  position: relative;
`;

export const CheckIconContainer = styled.span`
  color: ${({ theme }) => theme.palette.primaryExtended.opacityBackgroundText};
  line-height: 62.5%;
`;
